import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import TimePicker from 'react-bootstrap-time-picker';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import data_criticity from 'src/data/criticity';
import InputFormAssociated from '../input/inputFormAssociated';
import withAuth from 'src/hoc/withAuth';

const oriState = {
  title: null,
  text: null,
  date: undefined,
  time: 12 * 3600,
  notifDelay: 0,
  criticity: -1,
};

class ModalReminderPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      date: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }
  handleTimeChange(time) {
    this.setState({ time });
  }

  componentDidMount() {}

  checkFormValid() {
    return (
      this.state.title &&
      this.state.criticity &&
      this.state.criticity !== -1 &&
      this.state.date &&
      this.state.time &&
      this.state.notifDelay &&
      this.state.notifDelay !== 0
    );
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Rappel</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Titre</label>
                  <input
                    name='title'
                    value={this.state.title}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Retrouver le rappel plus tard'
                  />
                </div>
                <div className='form-group'>
                  <label>Texte</label>
                  <textarea
                    name='text'
                    value={this.state.text}
                    onChange={this.handleInputChange}
                    className='form-control'
                    placeholder='Contenu du rappel (facultatif)'
                  />
                </div>
                <div className='form-group'>
                  <label>Criticité</label>
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option value={-1}>Sélectionner criticité</option>
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Date de rappel</label>
                  <DatePicker
                    calendarContainer={this}
                    name='date'
                    defaultValue={moment().format('YYYY-MM-DD')}
                    value={this.state.date}
                    onChange={this.handleDateChange}
                    dateFormat='YYYY-MM-DD'
                  />
                </div>
                <div className='form-group'>
                  <label>Heure de rappel</label>
                  <TimePicker
                    format={24}
                    initialValue={'12:00'}
                    onChange={this.handleTimeChange}
                    value={this.state.time}
                  />
                </div>
                <div className='form-group'>
                  <label>Rappel avant (min)</label>
                  <input
                    min='0'
                    name='notifDelay'
                    value={this.state.notifDelay}
                    onChange={this.handleInputChange}
                    type='number'
                    className='form-control'
                  />
                </div>
                {this.props.entityAssociated && <InputFormAssociated entityAssociated={this.props.entityAssociated} />}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          reminder: {
            title: this.state.title,
            text: this.state.text ? this.state.text : '', // optional
            dateRecall: moment(this.state.date).seconds(this.state.time).format('YYYY-MM-DD HH:mm'),
            timeBeforeAlert: this.state.notifDelay,
            criticity: this.state.criticity,
          },
        };
        // If present -> set the Major Entity associated
        if (this.props.entityAssociated) {
          json.reminder['relativeTo'] = {
            [this.props.entityAssociated.type]: {
              id: this.props.entityAssociated.id,
            },
          };
        }

        this.props.onPostResult('reminder', postEntity(this.props.authFetch, 'reminder', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalReminderPost);
